import React, { useMemo, useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

/**
 * Statistics Page
 * - Header + date range picker (single MDDatePicker)
 * - 4 square blocks (responsive)
 * - Mobile friendly
 */
const TrafficPage = () => {

  return (
    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>

</Grid>
</MDBox>
    </DashboardLayout>
  );
};

export default TrafficPage;
